import styled from 'styled-components';
import theme from '../../theme';

const Container = styled.div`
  cursor: pointer;
  margin-bottom: 80px;

  > ul {  
    margin-top: 20px;
    list-style-type: none;

    > li, span {
      font-size: 14px;
      font-weight: 700;
      color: ${theme.textDark};
      margin-bottom: 5px;
      display: block;
    } 

    > li + li {
      margin-top: 20px;
    }
  }
`;

const Content = styled.div`
  border-left: 2px solid ${theme.textDark};
  padding-left: 10px;
`;

const Recipients = styled.ul`
  list-style-type: none;
  width: calc(100% - 20px);
  padding-left: 20px;

  li + li {
    border-top: 1px solid #ccc;
  }    

  li:first-child {
    padding-top: 0;
  }

  li:last-child {
    padding-bottom: 0;
  }

  li {
    display: flex;
    justify-content: space-between;
    align-items: end;
    padding: 5px 0;

      div {
        display: flex;
        flex-direction: column;

        small {
          font-size: 11px;
          font-weight: 400;
          color: ${theme.textDark};
        }
      }

      > span {
        font-size: 14px;
        font-weight: 500;
        color: ${theme.textLight};
      }
    }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 28px;
  padding-bottom: 5px;
`;

const ExhibitorHeader = styled.div`
    display: flex;
    align-items: center;

    img {
        width: 24px;
        height: 24px;
    }

    div {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        
        strong {
            font-size: 11px;
            font-weight: 700;
            color: ${theme.textDark};
        }

        small {
            font-size: 11px;
            font-weight: 400;
            color: ${theme.textDark};
        }
    }
`;

const AmountHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  svg {
    width: 13px;
    height: 13px;
  }

  span {
    font-size: 16px;
    font-weight: 900;
    color: ${theme.primaryColor} !important;
  }
`;

const NoData = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.textDark};
  text-align: center;
  margin-top: calc(50vh - 70px);
`;

export {
  Container,
  Header,
  ExhibitorHeader,
  AmountHeader,
  Content,
  Recipients,
  NoData
};